module.exports = __webpack_public_path__ + "img/expert_box.8e078951.png";